import useDefaultInputStyles from "../../hooks/useDefaultInputStyles";
import React, { forwardRef } from "react";

const Input = forwardRef((props: any, ref) => {

    props = useDefaultInputStyles(props);

    return (
        <input {...props} ref={ref}></input>
    )

})  

export default Input;